import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {JobMode} from "./JobMode";
import {JobConfig} from "./JobConfig";

export class JobModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(JobModel, v) : SKIP;
            },
            (v) => {
                return deserialize(JobModel, v);
            }
        );
    }

    constructor(mode = JobMode.TOUCH) {
        super();
        this._mode = mode;
        this._data = [];
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    valid() {

        if (this.mode.equal(JobMode.CUSTOM)) {
            // can have tasks

            if (this.data && this.data.some(v => !v || !v.valid())) {
                return false;
            }

        } else if (this.mode.equal(JobMode.TRADER)) {

            if (this.data && this.data.length > 0) {
                return false;
            }

        } else {

            if (!this.data || this.data.length === 0) {
                return false;
            }

            if (this.data && this.data.some(v => !v || !v.valid())) {
                return false;
            }
        }

        return true;
    }

    empty() {
        return false;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new JobModel());
        } else if (target instanceof JobModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(JobModel, {
    _mode: alias("type", JobMode.schema()),
    _data: alias("data", list(JobConfig.schema()))
});
